import { render, staticRenderFns } from "./TarefaManutencao.vue?vue&type=template&id=d0cb62a4"
import script from "./TarefaManutencao.vue?vue&type=script&lang=js"
export * from "./TarefaManutencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports